import { hasEnumData, hasPrimitiveData, requiresOptions } from "./guards";
import { matchDataType } from "./patternMatching";
// === Declarative Field Property Extraction (using existing schema) ===
export function getFieldLabel(fieldParameter) {
    return fieldParameter.display.primaryLabel;
}
export function getFieldKey(fieldParameter) {
    return fieldParameter.key;
}
// === Declarative Data Type Analysis (using existing schema) ===
export function getResourceType(fieldParameter) {
    return matchDataType(fieldParameter.dataType, {
        EnumData: (dataType) => dataType.resourceType,
        PrimitiveData: () => null,
        None: () => null,
    });
}
export function getResourceKinds(fieldParameter) {
    const resourceType = getResourceType(fieldParameter);
    if (resourceType?.kinds === undefined) {
        return [];
    }
    if (Array.isArray(resourceType.kinds)) {
        return resourceType.kinds;
    }
    return [resourceType.kinds];
}
export function getPrimitiveFormat(fieldParameter) {
    return matchDataType(fieldParameter.dataType, {
        PrimitiveData: (dataType) => dataType.format,
        EnumData: () => null,
        None: () => null,
    });
}
export function getValidationRules(fieldParameter) {
    if (!fieldParameter.dataType?.validation) {
        return [];
    }
    return fieldParameter.dataType.validation.map((validator) => ({
        type: validator.function,
        errorMessage: validator.errorMessage,
    }));
}
// === Declarative Field Analysis (using existing schema) ===
export function analyzeField(fieldParameter) {
    return {
        isEnum: hasEnumData(fieldParameter),
        isPrimitive: hasPrimitiveData(fieldParameter),
        requiresOptions: requiresOptions(fieldParameter),
        resourceType: getResourceType(fieldParameter),
        primitiveFormat: getPrimitiveFormat(fieldParameter),
    };
}
// === Convenience Functions (using existing schema types) ===
export function isEnumField(fieldParameter) {
    return hasEnumData(fieldParameter);
}
export function isPrimitiveField(fieldParameter) {
    return hasPrimitiveData(fieldParameter);
}
export function needsOptions(fieldParameter) {
    return requiresOptions(fieldParameter);
}
//# sourceMappingURL=fieldHelpers.js.map